import { Syllabus } from "../../types";
import SyllabusService from "../../services/Syllabus";

import { makeQueryKey as makeFetchSyllabusQueryKey } from "./useFetchSyllabus";
import useAuthorizedQuery from "../../common/hooks/useAuthorizedQuery";

export const makeQueryKey = (id?: Syllabus["id"]) => [
  ...makeFetchSyllabusQueryKey(id),
  "moves",
];

function useListSyllabusMoves(id?: Syllabus["id"]) {
  const key = makeQueryKey(id);

  return useAuthorizedQuery(
    key,
    () => {
      if (id) {
        return SyllabusService.listSyllabusMoves(id);
      }

      throw new Error("syllabus id is required");
    },
    { enabled: !!id }
  );
}

export default useListSyllabusMoves;
